module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.7.4-262.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.7.4.md
// module id = 705
// module chunks = 244